import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type StepCardWrapperProps = {
  isSticky?: boolean;
  title: string;
  headerChildren?: React.ReactNode;
  children?: React.ReactNode;
};

export function StepCardWrapper({
  title,
  headerChildren,
  children,
  isSticky = true,
}: StepCardWrapperProps) {
  return (
    <Card className={`${isSticky ? "sticky top-6" : ""} mb-2`}>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">{title}</CardTitle>
          <div className="flex items-center gap-1">{headerChildren}</div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">{children}</div>
      </CardContent>
    </Card>
  );
}
